import { useTranslation } from 'next-i18next';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { RootState } from '../../redux/store';
import SubmitButtonBase, { SubmitButtonBaseProps } from './SubmitButtonBase';

export type SubmitButtonProps = Omit<
  SubmitButtonBaseProps,
  'type' | 'disabled' | 'children'
>;

const SubmitButton: React.FC<SubmitButtonProps> = (props) => {
  const state = useSelector(
    (state: RootState) => ({
      isContactButtonLoading: state.contactForm.isContactButtonLoading,
      isContactFormSent: state.contactForm.isContactFormSent,
      isValidMessage: state.contactForm.isValidMessage,
      isWhatsappButtonLoading: state.contactForm.isWhatsappButtonLoading
    }),
    shallowEqual
  );
  const { t } = useTranslation('property');
  const contactText = t('contact');

  return (
    <SubmitButtonBase
      {...props}
      fullWidth
      type='submit'
      loading={state.isContactButtonLoading}
      disabled={
        state.isContactFormSent ||
        state.isWhatsappButtonLoading ||
        !state.isValidMessage
      }
    >
      {contactText}
    </SubmitButtonBase>
  );
};

export default SubmitButton;
